export function getApiErrorMessage(error: unknown): string | undefined {
    if (!error || typeof error !== 'object') {
        return undefined;
    }
    const e = error as { data?: { message?: string; error?: string }; message?: string };
    return e.data?.message ?? e.data?.error ?? e.message;
}

export function isApiNotFoundError(error: unknown): boolean {
    return typeof error === 'object' && error !== null && 'status' in error && error.status === 404;
}

/** A record that is missing or out of the viewer's reach: the API's error handler sends its page to /404. */
export function isApiMissingRecordError(error: unknown): boolean {
    const status = typeof error === 'object' && error !== null && 'status' in error ? error.status : undefined;
    return status === 404 || status === 403;
}
